import { createFileRoute, redirect } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import Loader from '@/components/common/Loader'

const PlayGroundPage = lazy(async () => {
  const module = await import('@/features/city-clerk/new-playground')
  return { default: module.PlayGroundPage }
})

export type NewPlaygroundSearch = {
  documentId?: string
  pageIndex?: number
  x?: number
  y?: number
}

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.playgroundView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  validateSearch: (search: Record<string, unknown>): NewPlaygroundSearch => {
    return {
      documentId:
        typeof search.documentId === 'string' ? search.documentId : undefined,
      pageIndex:
        typeof search.pageIndex === 'number'
          ? search.pageIndex
          : typeof search.pageIndex === 'string'
            ? parseInt(search.pageIndex, 10)
            : undefined,
      x:
        typeof search.x === 'number'
          ? search.x
          : typeof search.x === 'string'
            ? parseFloat(search.x)
            : undefined,
      y:
        typeof search.y === 'number'
          ? search.y
          : typeof search.y === 'string'
            ? parseFloat(search.y)
            : undefined,
    }
  },
  component: NewPlaygroundRouteComponent,
  pendingComponent: () => {
    return (
      <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
        <Loader size="lg" />
      </div>
    )
  },
})

function NewPlaygroundRouteComponent() {
  const search = Route.useSearch()
  const params = Route.useParams()
  return (
    <Suspense
      fallback={
        <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
          <Loader size="lg" />
        </div>
      }
    >
      <PlayGroundPage
        permitSubmitalId={params.permitSubmitalId}
        initialDocumentId={search.documentId}
        initialCommentTarget={
          search.documentId != null &&
          search.pageIndex != null &&
          search.x != null &&
          search.y != null
            ? {
                documentId: search.documentId,
                pageIndex: search.pageIndex,
                x: search.x,
                y: search.y,
              }
            : undefined
        }
      />
    </Suspense>
  )
}
